import { BodySmall, Heading, LayoutBox, LayoutTile, LayoutHorizontal, LayoutSpaceVertical } from 'breeze-intelligence-kit';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { BadgeAI } from './BadgeAI';
import { useSmartFillModal } from './SmartFill/SmartFillModal/useSmartFillModal/useSmartFillModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SmartPropertyInfo = () => {
  const {
    smartProperty
  } = useSmartFillModal();
  const {
    label,
    promptQuestion
  } = smartProperty;
  return /*#__PURE__*/_jsxs(LayoutTile, {
    overflow: "hidden",
    padding: "0",
    children: [/*#__PURE__*/_jsx(LayoutBox, {
      as: "header",
      background: "background-color",
      paddingBlock: "space-xs",
      paddingInline: "space-sm",
      children: /*#__PURE__*/_jsxs(LayoutHorizontal, {
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h6",
          children: label
        }), /*#__PURE__*/_jsx(BadgeAI, {})]
      })
    }), /*#__PURE__*/_jsx(LayoutBox, {
      padding: "space-sm",
      children: /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
        gap: "space-xxs",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h6",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "smartProperties.propertyPrompt"
          })
        }), /*#__PURE__*/_jsx(BodySmall, {
          children: promptQuestion
        })]
      })
    })]
  });
};